<template>
    <div>
        <v-card>
            <s-toolbar label="Aprobacion de Trabajo Remoto" dark color="#8e8f91" searchInput @textSearch="textSearch($event)" >
                <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            text
                            black
                            small
                            @click="validated(1)"
                           
                        > 
                            <v-icon>mdi-thumb-up</v-icon>
                        </v-btn>
                    </template>
                    <span>Aprobar</span>
                </v-tooltip>
                <!-- <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn 
                            v-on="on"
                            text
                            black
                            small
                            @click="approve(2)"
                            v-if="$fun.isAdmin()"
                        >
                            <v-icon>mdi-thumb-down</v-icon>
                        </v-btn>
                    </template>
                    <span>Desaprobar</span>
                </v-tooltip> -->
            </s-toolbar>
            <v-container>
				<v-row>
                    <v-col cols="12" md="4">
                        <s-select-area 
                            label="Area"
                            v-model="filter.AreID"
                            noDefault
                            full
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            item-key="RtwID"
                            dense
                            fixed-header
                            :items="items"
                            :headers="config.headers"
                            :items-per-page="10"
                            v-model="selected"
                            @click:row="rowClick"
                        >
                            <template v-slot:[`item.RtwDate`]="{ item }">
                                {{ $fun.formatDateView(item.RtwDate) }}
                            </template>
                            <template v-slot:[`item.TdrDateBegin`]="{ item }">
                                {{ $fun.formatDateTimeView(item.TdrDateBegin) }}
                            </template>
                            <template v-slot:[`item.TdrDateEnd`]="{ item }">
                                {{ $fun.formatDateTimeView(item.TdrDateEnd) }}
                            </template>
                            <template v-slot:[`item.TdrStatus`]="{ item }">
                                <v-chip
                                    x-small
                                    :color="getColor(item.RtwValidation)"
                                    dark
                                >
                                    {{ getText(item.RtwValidation) }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.Actions`]="{ item }">
                                <v-btn
                                    small
                                    color="purple-darken-4"
                                    class="mb-1"
                                    @click="openTasksDialog(item)"
                                    icon
                                >
                                    <v-icon>mdi-file-star-four-points-outline</v-icon>
                                </v-btn>

                                <v-btn
                                    icon
                                    small
                                    color="cyan darken-4" 
                                    dark
                                    class="mb-1"
                                    @click="editRemoteWorkDialog(item)"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog persistent v-if="openDialog" v-model="openDialog" max-width="600px">
            <s-Tasks :item="newData" @close="close"></s-Tasks>
        </v-dialog>

        <v-dialog v-model="showEditMarking" v-if="showEditMarking" persistent max-width="900">
            <v-card>
                <div style="padding: 16px 24px 10px">
                    <s-crud
                        height="auto"
                        title="Marcaciones de Trabajo Remoto"
                        :config="configAttendance"
                        :filter="filterAttendance"
                        searchInput
                        close
                        @close="closeEditMarking()"
                    >
                    <template v-slot:TdrStatusMarking="{ row }">
                        <v-chip x-small :color="row.MrkID === null ? 'orange' : 'green'" dark>{{ row.MrkID === null ? 'Por aprobar' : 'Aprobado' }}</v-chip>
                    </template>
                    </s-crud>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
    import _sAttendanceRemoteService from '@/services/HumanResource/Compensation/HmnAttendanceRemoteService.js';
    import _RemoteWorkService from "@/services/HumanResource/Compensation/HmnRemoteWorkService";
    import _sMassiveAssistanceGangService from "@/services/HumanResource/Compensation/HmnMassiveAssistanceGangService";
    import sTasks from '@/components/Utils/RecursosHm/sTasks.vue';
    
    export default {
        components: {
            sTasks
        },
        data() {
            return {
                filter:{
                    AreID: 1,
                },
                filterAttendance: {
                    RtwID: 0
                },
                items: [],
                selected: [],
                openDialog: false,
                newData: {},
                showEditMarking: false,
                itemApproval: {},
                searchText: "",
                listMarking: {},
                config: {
                    headers: [
                        { text: "ID", value: "RtwID" },
                        { text: "Trabajador", value: "NtpFullName" },
                        { text: "Area", value: "AreName" },
                        { text: "Día", value: "RtwDate" },
                        { text: "H. Inicio", value: "RtwHourBegin" },
                        { text: "H. Fin", value: "RtwHourEnd" },
                        { text: "Descripción", value: "RtwDescription" },
                        {text: "Estado"			                    , value: "TdrStatus"		    },
                        // {text: "Acciones"			                , value: "Actions"			    },
                    ],
                },
                configAttendance: {
                    service: _sAttendanceRemoteService,
                    model: {
                        TdrID: "ID",
                        TdrDateMarking: "datetime",
                    },
                    headers: [
                        {text: "ID"									, value: "TdrID"				},
                        {text: "N° Doc"								, value: "PrsDocumentNumber"	},
                        {text: "Nombres y Apellidos Completos"		, value: "NtpFullName"			},
                        {text: "Tipo Marcación"			            , value: "TdrTypeAttendanceName"},
                        {text: "Asistencia"			                , value: "TdrDateMarking"		},
                        {text: "Observacion"			            , value: "TdrObservation"		},
                        {text: "Estado"			                    , value: "TdrStatusMarking"		},
                    ],
                },
            }
        },
        methods:{
            load() {
                _sAttendanceRemoteService
                    .listValidation(this.filter, this.$fun.getUserID())
                    .then((r) => {
                        this.items = r.data;
                    });
            },
            rowClick: function(item, row) {
				if (item !== undefined) {
					this.selected = [item];
				}
			},
            openTasksDialog(item) {
                this.newData = {};
                this.newData.RtwID = item.RtwID;
                this.openDialog = true;
            },
            close() {
                this.openDialog = false;
                this.newData = {};
            },
            editRemoteWorkDialog(item) {
                this.editRemoteWork = {};
                this.editRemoteWork = item;
                this.filterAttendance.RtwID = item.RtwID;
                this.showEditMarking = true;
            },
            closeEditMarking() {
                this.showEditMarking = false;
                this.editRemoteWork = {};
            },
            getText(RtwValidation) {
                if (RtwValidation === null) {
                return 'Por aprobación.'
                } else if (RtwValidation === 1) {
                return 'Aprobado.'
                } else if (RtwValidation === 2) {
                return 'Desaprobado.'
                }
            },
            getColor(RtwValidation) {
                if (RtwValidation === null) {
                return 'grey'
                } else if (RtwValidation === 1) {
                return 'green'
                } else if (RtwValidation === 2) {
                return 'red'
                }
            },
            textSearch(text){
                this.filter.Search = text;
                this.load();
            },
            validated(value) {
                this.$fun.alert("Seguro de Guardar?", "question")
                    .then(r => {
                        if(r.value){
                            this.selected[0].RtwValidation = value;
                            _RemoteWorkService.save(this.selected[0], this.$fun.getUserID())
                            .then(resp => {
                                if(resp.status == 200){
                                    this.$fun.alert("Se agrego correctamente", "success");
                                    this.load();
                                }
                            });
                        }
                    });
            }
        },

        created() {
            this.filter.AreID =  this.$fun.getUserInfo().CtrContract.AreID ?? 0;
            this.load();
        },
        watch: {
            "filter.AreID"() {
                this.load();
            },
        },
    }
  </script>
  